export const userSchema = `
  id
  email
  givenName
  familyName
`;
